import { Box, Typography } from "@mui/material";
import { useState } from "react";

const ChooseDashboard = () => {
    const [hoveredSection, setHoveredSection] = useState(null);

    const sectionStyles = {
        position: "absolute",
        top: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
        overflow: "hidden",
    };

    const overlayStyles = {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
    };

    const contentStyles = {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    };

    const titleStyles = {
        fontFamily: "'Rajdhani', 'Orbitron', sans-serif",
        fontWeight: 700,
        letterSpacing: "0.15em",
        textTransform: "uppercase",
        textShadow: "0 0 30px rgba(255, 255, 255, 0.3)",
        transition: "all 0.4s ease",
    };

    const subtitleStyles = {
        fontFamily: "'Inter', sans-serif",
        fontWeight: 300,
        letterSpacing: "0.3em",
        textTransform: "uppercase",
        opacity: 0.7,
        transition: "all 0.4s ease",
    };

    // Le sezioni si sovrappongono al centro sulla linea obliqua

    return (
        <>
            {/* Diagonal Divider Line - elegante e professionale */}
            {/* Alone sottile */}
            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    left: "50%",
                    width: "12px",
                    height: "100vh",
                    background: "linear-gradient(180deg, transparent 0%, rgba(255,255,255,0.08) 20%, rgba(255,255,255,0.12) 50%, rgba(255,255,255,0.08) 80%, transparent 100%)",
                    transform: "rotate(11deg) translateX(-50%)",
                    transformOrigin: "center center",
                    zIndex: 9,
                    filter: "blur(6px)",
                    pointerEvents: "none",
                }}
            />
            {/* Linea principale */}
            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    left: "50%",
                    width: "3px",
                    height: "100vh",
                    background: "linear-gradient(180deg, transparent 0%, rgba(255,255,255,0.5) 10%, rgba(255,255,255,0.9) 50%, rgba(255,255,255,0.5) 90%, transparent 100%)",
                    transform: "rotate(11deg) translateX(-50%)",
                    transformOrigin: "center center",
                    zIndex: 10,
                    boxShadow: "0 0 8px rgba(255,255,255,0.4), 0 0 16px rgba(255,255,255,0.2)",
                }}
            />

            {/* Left Section - Agent Dashboard */}
            <Box
                sx={{
                    ...sectionStyles,
                    left: 0,
                    width: "55%",
                    clipPath: "polygon(0 0, 100% 0, calc(100% - 10vw) 100%, 0 100%)",
                }}
                onMouseEnter={() => setHoveredSection("left")}
                onMouseLeave={() => setHoveredSection(null)}
            >
                {/* Base dark overlay */}
                <Box
                    sx={{
                        ...overlayStyles,
                        background: "rgba(10, 15, 30, 0.85)",
                    }}
                />
                
                {/* Blue gradient converging to center line */}
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "linear-gradient(90deg, rgba(59, 130, 246, 0.05) 0%, rgba(59, 130, 246, 0.15) 40%, rgba(59, 130, 246, 0.35) 70%, rgba(59, 130, 246, 0.55) 100%)",
                        zIndex: 1,
                        opacity: hoveredSection === "left" ? 1 : 0.7,
                        transition: "opacity 0.4s ease",
                    }}
                />
                
                {/* Accent Glow al centro della sezione */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "40%",
                        width: hoveredSection === "left" ? "300px" : "200px",
                        height: hoveredSection === "left" ? "300px" : "200px",
                        background: "radial-gradient(circle, rgba(59, 130, 246, 0.2) 0%, transparent 70%)",
                        transform: "translate(-50%, -50%)",
                        transition: "all 0.4s ease",
                        zIndex: 1,
                    }}
                />

                <Box
                    sx={{
                        ...contentStyles,
                        transform: hoveredSection === "left" ? "scale(1.03)" : "scale(1)",
                    }}
                >
                    {/* LECS Logo */}
                    <Box
                        sx={{
                            width: "100px",
                            height: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            filter: hoveredSection === "left" 
                                ? "drop-shadow(0 0 20px rgba(59, 130, 246, 0.6))" 
                                : "none",
                            transition: "all 0.4s ease",
                        }}
                    >
                        <img 
                            src="/logoWhite.png" 
                            alt="LECS Logo"
                            style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </Box>

                    <Typography
                        sx={{
                            ...titleStyles,
                            fontSize: "2.2rem",
                            color: "#ffffff",
                        }}
                    >
                        Agent
                    </Typography>
                    
                    <Typography
                        sx={{
                            ...subtitleStyles,
                            fontSize: "0.85rem",
                            color: "rgba(59, 130, 246, 0.9)",
                        }}
                    >
                        Dashboard
                    </Typography>

                    {/* Enter Arrow */}
                    <Box
                        sx={{
                            opacity: hoveredSection === "left" ? 1 : 0,
                            transform: hoveredSection === "left" ? "translateY(0)" : "translateY(20px)",
                            transition: "all 0.4s ease",
                            marginTop: "20px",
                        }}
                    >
                        <svg 
                            width="30" 
                            height="30" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="rgba(255,255,255,0.8)"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                        </svg>
                    </Box>
                </Box>
            </Box>

            {/* Right Section - LECS Dashboard */}
            <Box
                sx={{
                    ...sectionStyles,
                    right: 0,
                    width: "55%",
                    clipPath: "polygon(10vw 0, 100% 0, 100% 100%, 0 100%)",
                }}
                onMouseEnter={() => setHoveredSection("right")}
                onMouseLeave={() => setHoveredSection(null)}
            >
                {/* Base dark overlay */}
                <Box
                    sx={{
                        ...overlayStyles,
                        background: "rgba(5, 5, 10, 0.92)",
                    }}
                />
                
                {/* Dark gradient converging to center line */}
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "linear-gradient(270deg, rgba(20, 20, 30, 0.3) 0%, rgba(30, 30, 40, 0.4) 40%, rgba(40, 40, 55, 0.5) 70%, rgba(60, 60, 80, 0.6) 100%)",
                        zIndex: 1,
                        opacity: hoveredSection === "right" ? 1 : 0.7,
                        transition: "opacity 0.4s ease",
                    }}
                />
                
                {/* Accent Glow al centro della sezione */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "60%",
                        width: hoveredSection === "right" ? "300px" : "200px",
                        height: hoveredSection === "right" ? "300px" : "200px",
                        background: "radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, transparent 70%)",
                        transform: "translate(-50%, -50%)",
                        transition: "all 0.4s ease",
                        zIndex: 1,
                    }}
                />

                <Box
                    sx={{
                        ...contentStyles,
                        transform: hoveredSection === "right" ? "scale(1.03)" : "scale(1)",
                    }}
                >
                    {/* LECS Logo */}
                    <Box
                        sx={{
                            width: "100px",
                            height: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            filter: hoveredSection === "right" 
                                ? "drop-shadow(0 0 20px rgba(255, 255, 255, 0.4))" 
                                : "none",
                            transition: "all 0.4s ease",
                        }}
                    >
                        <img 
                            src="/logoWhite.png" 
                            alt="LECS Logo"
                            style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </Box>

                    <Typography
                        sx={{
                            ...titleStyles,
                            fontSize: "2.2rem",
                            color: "#ffffff",
                        }}
                    >
                        LECS
                    </Typography>
                    
                    <Typography
                        sx={{
                            ...subtitleStyles,
                            fontSize: "0.85rem",
                            color: "rgba(255, 255, 255, 0.6)",
                        }}
                    >
                        Dashboard
                    </Typography>

                    {/* Enter Arrow */}
                    <Box
                        sx={{
                            opacity: hoveredSection === "right" ? 1 : 0,
                            transform: hoveredSection === "right" ? "translateY(0)" : "translateY(20px)",
                            transition: "all 0.4s ease",
                            marginTop: "20px",
                        }}
                    >
                        <svg 
                            width="30" 
                            height="30" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="rgba(255,255,255,0.8)"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                        </svg>
                    </Box>
                </Box>
            </Box>

            {/* Top Title */}
            <Box
                sx={{
                    position: "fixed",
                    top: "40px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 20,
                    textAlign: "center",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "'Rajdhani', 'Orbitron', sans-serif",
                        fontSize: "1.1rem",
                        fontWeight: 600,
                        letterSpacing: "0.3em",
                        textTransform: "uppercase",
                        color: "rgba(255,255,255,0.7)",
                        textShadow: "0 0 20px rgba(255,255,255,0.2)",
                    }}
                >
                    
                </Typography>
            </Box>
        </>
    );
};

export default ChooseDashboard;
